/* eslint-disable @next/next/no-img-element */

// @material-tailwind/react components
import { Typography } from "@material-tailwind/react";

// page components
import Testimonial from "components/cards/testimonial";

export default function SectionTestimonials() {
  return (
    <section className="py-10 md:py-24">
      <div className="mx-auto w-full text-center md:w-1/2">
        <Typography
          variant="h2"
          className="mb-2 font-black tracking-normal text-[#1A237E]"
        >
          Trusted by over <br />
          <Typography
            as="span"
            variant="h2"
            color="blue"
            className="inline-block font-black tracking-normal"
            textGradient
          >
            120+ Students
          </Typography>
        </Typography>
        <Typography className="text-lg text-[#1A237E]/60">
          Over 25+ companies have recruited students who have honed their skills
          through our platform. Our program has led to the successful placement
          of 100 students setting them on a path to professional success.
        </Typography>
      </div>
      <div className="mt-10 flex flex-wrap items-center">
        <div className="w-full md:w-1/2 md:px-4 lg:w-1/3">
          <Testimonial color="orange" name="Rahul Kumar" date="1 week ago">
            Rahul Kumar&apos;s accomplishment speaks volumes about the value of
            our program. With our guidance, he secured a coveted position as a
            Data Analyst at Accenture.
          </Testimonial>
        </div>
        <div className="w-full md:w-1/2 md:px-4 lg:w-1/3">
          <Testimonial color="blue" name="Manan Motwani" date="2 week ago">
            A dedicated participant of our Code Crush program, has achieved a
            remarkable placement with Amazon. His success story is a testament
            to the effectiveness of our program in preparing students for
            top-tier opportunities.
          </Testimonial>
        </div>
        <div className="w-full md:w-1/2 md:px-4 lg:w-1/3">
          <Testimonial color="green" name="Samarth Kamuli" date="3 weeks ago">
            Samarth Kamuli&apos;s achievement is a testament to the prowess of
            our program. Through our platform, he secured a significant role as
            a Software Developer at Netlify, underscoring our commitment to
            nurturing talent for success in the ever-evolving tech landscape.
          </Testimonial>
        </div>
        <div className="mt-16 flex items-center lg:mx-auto">
          <div className="mr-8 w-full px-12 md:w-1/5 md:px-4">
            <img
              className="w-auto"
              src="/img/logos/logo-amazon.webp"
              alt="tailwind_logo_amazon"
            />
          </div>
          <div className="mr-8 w-full px-12 md:w-1/5 md:px-4">
            <img
              className="w-auto"
              src="/img/logos/logo-ibm.webp"
              alt="tailwind_logo_ibm"
            />
          </div>
          <div className="mr-8 w-full px-12 md:w-1/5 md:px-4">
            <img
              className="w-auto"
              src="/img/logos/logo-microsoft.webp"
              alt="tailwind_logo_microsoft"
            />
          </div>
          <div className="mr-8 w-full px-12 md:w-1/5 md:px-4">
            <img
              className="w-auto"
              src="/img/logos/logo-cisco.webp"
              alt="tailwind_logo_cisco"
            />
          </div>
          <div className="w-full px-12 md:w-1/5 md:px-4">
            <img
              className="w-auto"
              src="/img/logos/logo-vodafone.webp"
              alt="tailwind_logo_vodafone"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
